/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Feed_Url_HintInputs */

const cs_import_feed_url_hint = /** @type {(inputs: Import_Feed_Url_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vložte odkaz na GetJobStamps.php (všechny nabídky) nebo GetJob.php?export_id=…&all_contracts=1 (jedna nabídka). Stáhneme ho na pozadí a ukážeme průběh.`)
};

const en_import_feed_url_hint = /** @type {(inputs: Import_Feed_Url_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the GetJobStamps.php link (all offers) or GetJob.php?export_id=…&all_contracts=1 (one offer). We download it in the background and show progress.`)
};

/**
* | output |
* | --- |
* | "Paste the GetJobStamps.php link (all offers) or GetJob.php?export_id=…&all_contracts=1 (one offer). We download it in the background and show progress." |
*
* @param {Import_Feed_Url_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_url_hint = /** @type {((inputs?: Import_Feed_Url_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_Url_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_url_hint(inputs)
	return cs_import_feed_url_hint(inputs)
});